export default {"src":"/_next/static/image/public/images/social_fb_blue.642a22e228bd9214067aabe116175660.svg","height":15,"width":8};